import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState, actions } from "../../state/reducer";
import PanelSearch from "../filters/panelSearch";
import { FilterIcon } from "../../icons/filter";
import { eventBackend } from "../../services";
import EventFilterModal from "../../modals/filters/event";
import { closeModal, openModal } from "../../state/modalSlice";
import { EventListRequestParams } from "../../forms/filters/event";

const EventSearchBlockWidget = () => {

  const State = useSelector((state: RootState) => state);
  const dispatch = useDispatch();
  const filters = State.eventListRequestParams

  const search = (value: string) => {
    dispatch(actions.eventRequestParams({...filters, search_query: value}))
  }

  const handleOpenFilters = () => {
    dispatch(openModal({ component: EventFilterModal, context: {
      onApplyFilters: (filters: EventListRequestParams) => {
        dispatch(actions.eventRequestParams(filters))
      },
      closeModal: () => dispatch(closeModal()), // Закрыть модальное окно через Redux
    }, }));
  }

  return (
    <div className="flex between panelSearchContainer w100">
      <PanelSearch hint={"Поиск по названию"} onChange={search} />
      <div className="btn filterBtn" onClick={handleOpenFilters}>
        <FilterIcon width={20} height={20} />
      </div>
    </div>
  );
};

export default EventSearchBlockWidget;
